<h1>Settings</h1>
<div class="row">
    <span>Nickname</span>
    <div style="display: flex;">
        <input type="text" maxlength="16" id="nickname" [placeholder]="loginName" autocomplete="false" [ngStyle]="{'color': usercolor}" [(ngModel)]="username" (input)="update()" (keydown.enter)="complete.next('')" />
        <app-colorpicker [(color)]="usercolor" (colorChange)="update()"></app-colorpicker>
    </div>
</div>
<div *ngIf="isOwner" class="divider"></div>
<div *ngIf="isOwner" class="row">
    <span>Room Password</span>
    <div style="display: flex;">
        <input type="text" id="room-password" [placeholder]="passwordInput" autocomplete="false" [(ngModel)]="passwordInput" (keydown.enter)="changePassword();" />
    </div>
</div>
<div class="divider"></div>
<div class="row center">
    <mat-slide-toggle class="menu-item" [(ngModel)]="swapmiddleright" (click)="update()" [labelPosition]="'before'">
        <span>Swap Middle/Right Click</span>
    </mat-slide-toggle>
</div>
<div class="row center">
    <mat-slide-toggle class="menu-item" [(ngModel)]="requiredragselect" (click)="update()" [labelPosition]="'before'">
        <span>Require Dragging for Group Select</span>
    </mat-slide-toggle>
</div>
<div class="row center">
    <mat-slide-toggle class="menu-item" [(ngModel)]="disablesfx" (click)="update()" [labelPosition]="'before'">
        <span>Disable Sound Effects</span>
    </mat-slide-toggle>
</div>
<div class="row center">
    <mat-slide-toggle class="menu-item" [(ngModel)]="opaquemacros" (click)="update()" [labelPosition]="'before'">
        <span>Use Opaque Macros</span>
    </mat-slide-toggle>
</div>
<div class="row center" style="margin-top: 40px;">
    <span>OpenAI API Key</span>
    <div style="display: flex;">
        <input type="text" id="openaikey" autocomplete="false" [(ngModel)]="openAiKey" (input)="update()" (keydown.enter)="complete.next('')" />
    </div>
</div>
<div class="row center" style="margin-top: 40px;">
    <mat-slide-toggle class="menu-item" [(ngModel)]="quality" (click)="toggleQuality()" [labelPosition]="'before'">
        <span class="toggle">High Quality Mode</span>
    </mat-slide-toggle>
    <button mat-button (click)="reloadWindow()" *ngIf="showReload" style="margin-top: 20px;">
        <mat-icon>refresh</mat-icon> <span>Reload Window</span>
    </button>
</div>
